import { toast } from 'sonner'
import { useState, useEffect } from 'react'
import { fError } from '@/utils/format-error'
import { useBoolean } from '@/hooks/use-boolean'
import { useParams } from '@/routes/hooks/use-params'
import axiosInstance, { endpoints } from '@/lib/axios'
import LoadingSection from '@/components/loading-indicator/loading-section'

import type { Privilege } from '../privilege.types'

import PrivilegeForm from '../privilege-form'

// ----------------------------------------------------------------------

export default function PrivilegeFormView() {
  const params = useParams()
  const loading = useBoolean(true)
  const [privilege, setPrivilege] = useState<Privilege | undefined>(undefined)
  const isEditMode = params.id !== undefined

  const fetchPrivilege = async () => {
    if (!isEditMode || !params.id) {
      loading.onFalse()
      return
    }

    try {
      loading.onTrue()
      const { data } = await axiosInstance.get<Privilege>(
        endpoints.privileges.detail(params.id),
      )
      setPrivilege(data)
    } catch (error) {
      toast.error(fError(error))
    } finally {
      loading.onFalse()
    }
  }

  useEffect(() => {
    fetchPrivilege()
  }, [params.id])

  return (
    <LoadingSection loading={loading.value}>
      <PrivilegeForm
        privilege={privilege}
        mode={isEditMode ? 'edit' : 'create'}
      />
    </LoadingSection>
  )
}
